<div fxShow="true" fxShow.gt-sm="false">
    <div class="header-title cp">{{title}}</div>
</div>
